/**
 * @flow
 */

import React from 'react';
import { Route } from 'react-router-dom';
import { AuthenticatedRoute } from '../components';
import styled from 'styled-components';

import { Container as BaseContainer } from 'semantic-ui-react';

// Import semantic UI stylesheets
import 'semantic-ui-css/semantic.min.css';

import { ChangePasswordPage, VerifyEmailPage } from '../pages';
import { SalonLayout } from './salon';
import { SupplierLayout } from './supplier';
import LoginPage from '../pages/login/components/LoginPage';
import ResetPasswordPage from '../pages/login/components/ResetPasswordPage';
import SignupPage from '../pages/signup/containers/SignupPage';

const Container = styled(BaseContainer)`
    height: 100%;
`;

const RedirectAppstore = () => {
    if (navigator.userAgent.toLowerCase().includes('iphone')) {
        window.location.href = "https://apps.apple.com/app/appotime/id1418595516"
    } else {
        window.location.href = "https://play.google.com/store/apps/details?id=com.appotime"
    }
    return null
}

const App = () => (
    <Container fluid>
        <Route exact path="/" component={LoginPage} />
        <Route exact path="/forgot" component={ResetPasswordPage} />
        <Route exact path="/signup" component={SignupPage} />
        <Route
            exact
            path="/change-password/:token"
            component={ChangePasswordPage}
        />
        <Route
            exact
            path="/verify-email/:email/:token"
            component={VerifyEmailPage}
        />
        <Route
            exact
            path="/master/:token"
            component={RedirectAppstore}
        />
        <AuthenticatedRoute path="/salon" component={SalonLayout} />
        <AuthenticatedRoute path="/supplier" component={SupplierLayout} />
    </Container>
);

export default App;
